import { DataTableAction, DataTableLabel, Flex, Link, Text } from '@optiaxiom/react';

import { UnifiedAgent } from '@frontend/types/agent';

type NameCellProps = {
  agent: UnifiedAgent;
  onClick: (agent: UnifiedAgent) => void;
};

export const NameCell = ({ agent, onClick }: NameCellProps) => {
  return (
    <Flex flexDirection="column" gap="4" alignItems="start">
      <DataTableLabel asChild>
        <DataTableAction overflow="hidden" primary>
          <Link appearance="subtle" href="data:," onClick={() => onClick(agent)}>
            <Text>{agent.name}</Text>
          </Link>
        </DataTableAction>
      </DataTableLabel>
      <Text fontSize="sm" color="fg.tertiary">
        @{agent.agent_id}
      </Text>
    </Flex>
  );
};
